import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LINKS = {
  calendly: "https://calendly.com/contactyashbhatt/30min",
  linkedin: "https://www.linkedin.com/in/yash-bhatt-anand/",
  email: "contact@bhattyash.com",
  x: "https://x.com/",
  github: "https://github.com/",
};

export const EXPERTISE_GROUPS = [
  { group: "AI & Strategy", skills: ["AI Strategy", "AI Adoption", "Product Strategy", "Business Transformation"] },
  { group: "Enterprise Consulting", skills: ["Solution Consulting", "Sales Engineering", "Technical Consulting", "Customer Discovery"] },
  { group: "Data & Analytics", skills: ["Analytics", "Data Visualization", "ROI Modeling", "Executive Dashboards"] },
  { group: "Leadership", skills: ["Executive Presentations", "Stakeholder Management", "Workshop Facilitation", "Strategic Roadmapping"] },
];

export const EXPERTISE = EXPERTISE_GROUPS.flatMap((g) => g.skills);

export const TIMELINE = [
  { year: "2025 - Now", role: "Solutions Consultant", org: "Axion Ray", detail: "Leading AI solution consulting across enterprise opportunities - 7 strategic deals, ~40% faster solution turnaround, 3x engagement capacity." },
  { year: "2023 - 2025", role: "Independent Solutions Consultant", org: "AI & GTM Strategy", detail: "Advised SaaS startups and growth-stage organizations on GTM, analytics adoption, and ROI modeling - cutting manual reporting effort by up to 50%." },
  { year: "2022 - 2023", role: "Senior Research Associate", org: "Google (GOC)", detail: "Data-backed recommendations that influenced 25 product roadmap and GTM decisions; reporting cycles shortened by 35%." },
  { year: "2020 - 2022", role: "Financial Analyst", org: "Oceaneering International", detail: "Automated forecasting and reporting - $120K annual savings, 60% fewer reporting errors, 27 hours/month reclaimed." },
  { year: "2019 - 2020", role: "Data Analyst - Financial Research", org: "S&P Global", detail: "Client-facing analytical advisory with Lean Six Sigma - process defects reduced by 35%." },
];

export const PROCESS = [
  { step: "01", title: "Discovery", detail: "Deep consultative discovery - your business problem, stack, stakeholders, and success criteria. No pitch decks." },
  { step: "02", title: "Assessment", detail: "Data, workflow, and readiness audit. Where AI and automation create real leverage - and where they don't." },
  { step: "03", title: "Strategy", detail: "A prioritized roadmap with ROI models (TCO, NPV, IRR), governance guardrails, and executive-ready narratives." },
  { step: "04", title: "Implementation", detail: "Solution architecture, vendor alignment, and hands-on build oversight - LLMs, RAG, BI integration, automation." },
  { step: "05", title: "Optimization", detail: "Monitoring, fault-tolerant runbooks, and iteration loops that compound value instead of decaying." },
  { step: "06", title: "Results", detail: "Measured business outcomes - decision velocity, time-to-value, and cost efficiency you can put in a board deck." },
];

const ContentContext = createContext(null);

const EMPTY = { projects: [], posts: [], testimonials: [], metrics: [], services: [], resources: [], speaking: [], faqs: [], achievements: [], education: [] };

export function ContentProvider({ children }) {
  const [content, setContent] = useState(EMPTY);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content`).then(({ data }) => {
      setContent({ ...EMPTY, ...data });
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  return <ContentContext.Provider value={{ ...content, loaded }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
